import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import {
  ConfiguratorModuleAddPayload,
  ConfiguratorModuleEditPayload,
} from './configuratorModule.interface';

@Injectable({
  providedIn: 'root',
})
export class ConfiguratorModuleService {
  private token!: string;
  private httpOptions: any;

  private basePath = environment.interop.basePath;
  private getModuleGroupPermissionAssignedDTURL =
    this.basePath +
    environment.interop.platform.app.settings.moduleGroupPermissionAssigned
      .getModuleGroupPermissionAssignedDT;
  private storeModuleGroupPermissionAssignedDTURL =
    this.basePath +
    environment.interop.platform.app.settings.moduleGroupPermissionAssigned
      .storeModuleGroupPermissionAssigned;
  private updateModuleGroupPermissionAssignedDTURL =
    this.basePath +
    environment.interop.platform.app.settings.moduleGroupPermissionAssigned
      .updateModuleGroupPermissionAssigned;
  private deleteModuleGroupPermissionAssignedDTURL =
    this.basePath +
    environment.interop.platform.app.settings.moduleGroupPermissionAssigned
      .deleteModuleGroupPermissionAssigned;

  constructor(private http: HttpClient) {}

  getGroupPermissionDT() {
    return this.http.get(
      this.getModuleGroupPermissionAssignedDTURL,
      this.httpOptions
    );
  }

  addGroupPermission(permission: ConfiguratorModuleAddPayload) {
    return this.http.post(
      this.storeModuleGroupPermissionAssignedDTURL,
      permission,
      this.httpOptions
    );
  }

  updateGroupPermission(permission: ConfiguratorModuleEditPayload) {
    return this.http.put(
      this.updateModuleGroupPermissionAssignedDTURL,
      permission,
      this.httpOptions
    );
  }

  deleteGroupPermission(id: number) {
    return this.http.delete(this.deleteModuleGroupPermissionAssignedDTURL + id);
  }

  setToken(token: string) {
    this.token = token;
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${this.token}`,
      }),
    };
  }
}
